import intersection from 'lodash/intersection';
import { get } from 'lodash';

import createAsyncAction from 'shared/utils/createAsyncAction';
import { getDataFromError } from 'shared/utils/errorAction';

import createAction from './';
import { startLockdown } from './lockdown';
import { handleCommonErrors } from './commonErrors';
import { OTP_CODE_PATTERN } from '../utils/patterns';
import { sendOtpCode as apiSendOtpCode } from './sendOtpCode';
import { sendIdentityInfo as apiResendOtpCode } from './resendOtpCode';
import { otpCodeInputErrorCodes } from '../components/OtpForm/OtpForm';
import { LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS } from '../constants/apiErrorCodes';
import { EMPTY_OTP_CODE_LOCAL, INVALID_OTP_CODE_LOCAL } from '../constants/localErrorCodes';

export const ADD_LOCAL_ERROR_CODES = createAction('ADD_LOCAL_ERROR_CODES');
export const RESET_ERROR_CODES = createAction('RESET_ERROR_CODES');
export const SUBMIT_OTP_FORM = createAsyncAction(createAction('SUBMIT_OTP_FORM'));

export const knownErrors = [...otpCodeInputErrorCodes];

const clientErrorHandlers = {
  [EMPTY_OTP_CODE_LOCAL]: (value) => (value.length === 0),
  [INVALID_OTP_CODE_LOCAL]: (value) => (!value.match(OTP_CODE_PATTERN)),
};

const clientVerification = (otpCodeValue) => (dispatch) => {
  const errorCodes = Object.keys(clientErrorHandlers)
    .filter((key) => clientErrorHandlers[key](otpCodeValue))
    .map(Number);

  return dispatch({
    type: ADD_LOCAL_ERROR_CODES,
    meta: { errorCodes },
  });
};

export const resetErrorsIfNeeded = () => (dispatch, getState) => {
  const errorCodes = getState().auth.otpForm.errorCodes;
  if (errorCodes.length) {
    return dispatch({ type: RESET_ERROR_CODES });
  }
};

export const resendOtpCode = () => (dispatch, getState) => {
  return dispatch(apiResendOtpCode())
    .catch(({ graphQLErrors = [] }) => {
      const nextErrorCodes = getState().auth.otpForm.errorCodes;

      const handledErrorCodes = intersection(nextErrorCodes, knownErrors);
      if (handledErrorCodes.length === 0) {
        dispatch(handleCommonErrors(nextErrorCodes, false));
      }

      if (nextErrorCodes.includes(LOGIN_FREEZED_DUE_TO_MANY_ATTEMPTS)) {
        const unfreezeTimestamp = get(graphQLErrors, '[0].extensions.properties.unfreezeTimestamp');
        dispatch(startLockdown(unfreezeTimestamp));
      }
    });
};

export const submitOtpForm = (otpCodeValue) => (dispatch, getState) => {
  dispatch(clientVerification(otpCodeValue));

  const errorCodes = getState().auth.otpForm.errorCodes;
  if (errorCodes.length) {
    console.log('[otpForm] localErrorCodes:', errorCodes);
    return;
  }

  return dispatch(apiSendOtpCode(otpCodeValue))
    .then(() => dispatch({ type: SUBMIT_OTP_FORM.success }))
    .catch(() => {
      const nextErrorCodes = getState().auth.otpForm.errorCodes;
      const handledErrorCodes = intersection(nextErrorCodes, knownErrors);

      if (handledErrorCodes.length === 0) {
        dispatch(handleCommonErrors(nextErrorCodes));
      }
    });
};
